import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';

import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

const defaultButtonTitleValues = [
    { title: 'Yes', value: true },
    { title: 'No', value: false }
];


const Container = styled.div`
  display:flex;
  justify-content: space-between;
  text-align:center;
  align-items:center;
`;



const FormikSimpleSelect = ({ loading, value, setFieldValue = () => { }, setFieldTouched = () => { }, field, buttonTitleValues = defaultButtonTitleValues, onValueChanged, allowClear = true, OnOptionClick = () => { } }) => {

    let menuItems = buttonTitleValues.map(titleValue => <MenuItem key={titleValue.value} value={titleValue.value} onClick={() => { setFieldValue(field, titleValue.value); setFieldTouched(field); OnOptionClick(titleValue.value) }}>{titleValue.description ? titleValue.description : titleValue.title}</MenuItem>);
    const keyValues = _.mapValues(_.keyBy(buttonTitleValues, 'value'), 'title');
    const clearMenuItem = <MenuItem key="Clear" value={null}></MenuItem>
    menuItems = allowClear ? [clearMenuItem, ...menuItems] : menuItems;

    return (
        <Container>
            {loading ?
                <CircularProgress size={20} />
                :
                <Select
                    renderValue={value => keyValues[value]}
                    fullWidth
                    value={value}
                    onChange={event => {
                        setFieldValue(field, event.target.value);
                        setFieldTouched(field);

                        if (onValueChanged) {
                            onValueChanged(event.target.value);
                        }
                    }}
                >
                    {menuItems}
                </Select>
            }
        </Container>

    );
}

export default FormikSimpleSelect;
